import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import camelcaseKeys from 'camelcase-keys'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronRight } from '@fortawesome/free-solid-svg-icons'

import reserveApi from '../../../utils/axios'

import Sync from './Sync'
import FacilityGroupsTable from '../FacilityGroups/Table'
import FacilityGroupsAdd from '../FacilityGroups/Add'
import { Disclosure } from '@headlessui/react'

const Show = () => {
  const facility = useSelector(store => store.facilities.facility)
  const [adminFacility, setAdminFacility] = useState({})
  const [refresh, setRefresh] = useState(0)

  useEffect(() => {
    reserveApi.get(`/admin/facilities/${facility.id}`).then(response => {
      setAdminFacility(camelcaseKeys(response.data, { deep: true }))
    })
  }, [facility, refresh])

  const facilityGroupActions = [
    {
      label: 'Remove',
      onClick: value => {
        reserveApi({
          method: 'post',
          url: '/admin/facility_groups/remove',
          data: { facility_group_id: value.id, facility_id: facility.id }
        }).then(response => {
          setRefresh(refresh + 1)
        })
      }
    }
  ]

  return (
    <div className="min-h-screen">
      <div className="font-semibold text-lg border-b border-gray-200 my-4">Facility/Marketing Groups </div>
      {adminFacility.facilityGroups && (
        <FacilityGroupsTable facilityGroups={adminFacility.facilityGroups} actions={facilityGroupActions} />
      )}
      <FacilityGroupsAdd facilityId={facility.id} afterAdd={() => setRefresh(refresh + 1)} />

      <div className="font-semibold text-lg border-b border-gray-200 my-4">Site Data Sync</div>
      <Sync />

      <Disclosure>
        {({ open }) => (
          <div className="">
            <Disclosure.Button className="border-b-2 border-green-200 px-1 cursor-pointer w-full flex justify-between space-x-6">
              <span className="text-lg">External Details</span>

              <FontAwesomeIcon icon={faChevronRight} className={`${open ? 'transform rotate-90' : ''}`} />
            </Disclosure.Button>

            <Disclosure.Panel>
              <div className="whitespace-pre-wrap bg-gray-50 p-4">{JSON.stringify(adminFacility.details, null, 2)}</div>
            </Disclosure.Panel>
          </div>
        )}
      </Disclosure>
    </div>
  )
}

export default Show
